/*
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projectPage';

export default defineMessages({
  projectPageAllContent: {
    id: `${scope}.projectPageAllContent`,
    defaultMessage: 'ALL CONTENT',
  },
  projectPageSettings: {
    id: `${scope}.projectPageSettings`,
    defaultMessage: 'SETTINGS',
  },
  projectPageImportHistory: {
    id: `${scope}.projectPageImportHistory`,
    defaultMessage: 'IMPORT HISTORY',
  },
  projectPagePublicationDetail: {
    id: `${scope}.projectPagePublicationDetail`,
    defaultMessage: 'PUBLICATION DETAILS',
  },
  duplicateToBVStarted: {
    id: `${scope}.duplicateToBVStarted`,
    defaultMessage: 'Duplicate to BV started - processing, please wait.',
  },
  duplicateInProgress: {
    id: `${scope}.duplicateInProgress`,
    defaultMessage: 'Course duplication in progress',
  },
  duplicateFailed: {
    id: `${scope}.duplicateFailed`,
    defaultMessage: 'Course duplication failed. Please try again.',
  },
  authorNameRequired: {
    id: `${scope}.authorNameRequired`,
    defaultMessage: 'Add an author name in the Author Name field before duplicating this course.',
  },
  projectPageNoPublicationsFound: {
    id: `${scope}.projectPageNoPublicationsFound`,
    defaultMessage: 'No published content found.',
  },
});
